/* Chahal Agri Farms — member badge/price on product cards, login prompt,
 * and automatic member-discount application.
 * -----------------------------------------------------------------
 * Every product card carries a member signal, for everyone:
 *   - Members (body[data-caf-member="true"]) see a green MEMBER badge, the
 *     regular price struck through, and their actual member price.
 *   - Non-members see the regular price unchanged, plus a gold FAMILY line
 *     underneath teasing the member price and linking to the join page.
 *     The real price is never hidden from a non-member.
 * The membership product itself is skipped (no discount on a discount).
 *
 * For logged-in valid members the member discount code is also auto-applied
 * once per session, so the discount is already on the cart at checkout and
 * the member never types a code.
 *
 * v100 Diwali Sale: while the Diwali bar (#caf-dw-bar, rendered only during
 * the sale) is in the page, members get 20% instead of 12%, and the card's
 * visible price is the 15%-off Diwali price — so the member price is worked
 * out from the real price in data-caf-base (paise), not from the shown text.
 *
 * Progressive enhancement: if this never runs, nothing breaks — prices and
 * checkout behave normally.
 */
(function () {
  'use strict';

  var IS_DIWALI = !!document.getElementById('caf-dw-bar');
  var RATE = IS_DIWALI ? 0.8 : 0.88; /* Chahal Family discount: 20% in Diwali, else 12% */
  var PCT = IS_DIWALI ? 20 : 12;
  var MEMBER_CODE = 'FAMILY12'; /* member-segment-restricted automatic-apply code */
  var JOIN_URL = '/pages/membership';
  var MEMBERSHIP_HANDLE = 'chahal-family-membership-1-year';

  var body = document.body;
  var isMember = body && body.getAttribute('data-caf-member') === 'true';
  var loggedIn = body && body.getAttribute('data-caf-logged-in') === 'true';

  function parseRupees(txt) {
    var m = String(txt == null ? '' : txt).match(/[\d][\d,]*(?:\.\d+)?/);
    if (!m) return null;
    var v = parseFloat(m[0].replace(/,/g, ''));
    return isFinite(v) ? v : null;
  }
  function fmt(n) {
    return 'Rs. ' + n.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* The membership product must not advertise a member price on itself. */
  function isMembershipCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    return !!(link && link.getAttribute('href').indexOf(MEMBERSHIP_HANDLE) !== -1);
  }

  /* --- Auto-apply the member discount code once per browsing session --- */
  function applyMemberDiscount() {
    if (!isMember) return;
    try {
      if (sessionStorage.getItem('caf_member_discount_applied') === '1') return;
      sessionStorage.setItem('caf_member_discount_applied', '1');
    } catch (e) { /* private mode: fall through, will re-apply, harmless */ }
    /* Shopify's shareable-discount endpoint sets the cart discount cookie so it
       carries into checkout. Fired in the background so there's no redirect. */
    try {
      fetch('/discount/' + encodeURIComponent(MEMBER_CODE), {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'include',
        redirect: 'follow'
      });
    } catch (e) { /* ignore — code can still be applied at checkout */ }
  }

  /* --- Decorate every product card with the member signal --- */
  function decorateCards() {
    var cards = document.querySelectorAll('product-card:not([data-caf-done])');
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.price__regular, .price .price-item, .price');
      if (!priceEl) return;
      var baseEl = card.querySelector('[data-caf-base]');
      var rupees = baseEl
        ? parseInt(baseEl.getAttribute('data-caf-base'), 10) / 100
        : parseRupees(priceEl.textContent);
      if (rupees == null || !isFinite(rupees)) return;
      card.setAttribute('data-caf-done', '1');
      if (isMembershipCard(card)) return;

      var member = Math.round(rupees * RATE * 100) / 100;

      if (isMember) {
        /* Member: the member price becomes the headline price. */
        var badge = document.createElement('span');
        badge.className = 'caf-mcard-badge';
        badge.textContent = 'MEMBER';

        var wrap = document.createElement('div');
        wrap.className = 'caf-mcard-price';
        wrap.innerHTML =
          '<span class="caf-mcard-price__was">' + fmt(rupees) + '</span>' +
          '<span class="caf-mcard-price__now">' + fmt(member) + '</span>' +
          '<span class="caf-mcard-price__tag">' + (IS_DIWALI ? 'member &middot; Diwali' : 'member') + '</span>';

        priceEl.insertAdjacentElement('beforebegin', badge);
        priceEl.insertAdjacentElement('afterend', wrap);
        priceEl.style.display = 'none';
      } else {
        /* Non-member: real price stays as-is; member price is a teaser below. */
        var teaser = document.createElement('div');
        teaser.className = 'caf-mcard-teaser';
        teaser.innerHTML =
          '<span class="caf-mcard-teaser__badge">FAMILY</span>' +
          '<span class="caf-mcard-teaser__price">' + fmt(member) + '</span>' +
          '<a class="caf-mcard-teaser__link" href="' + JOIN_URL + '">for members</a>';
        priceEl.insertAdjacentElement('afterend', teaser);
      }
    });
  }

  /* --- Login prompt for non-logged-in shoppers (cart) --- */
  function addLoginPrompt() {
    if (isMember || loggedIn) return;
    var cart = document.querySelector(
      'cart-drawer .drawer__inner, #CartDrawer .drawer__inner, .cart__contents, cart-items'
    );
    if (!cart || cart.querySelector('.caf-login-prompt')) return;
    var el = document.createElement('div');
    el.className = 'caf-login-prompt';
    el.innerHTML =
      'Chahal Family member? <a href="/account/login">Log in</a> for your ' + PCT + '% member price — applied automatically.';
    cart.insertAdjacentElement('afterbegin', el);
  }

  function tick() {
    decorateCards();
    addLoginPrompt();
  }

  function boot() {
    applyMemberDiscount();
    tick();
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(tick, 150);
    });
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
